// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__n1lvd {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 5px;
}
@media (max-width: 1200px) {
  .styles_wrapper__n1lvd {
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 16px;
  }
  .styles_wrapper__n1lvd > div:nth-of-type(3) {
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 2;
  }
}
@media (max-width: 992px) {
  .styles_wrapper__n1lvd {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: unset;
  }
  .styles_wrapper__n1lvd > div:nth-of-type(3) {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 3;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/heading/specList/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,qCAAA;EACA,oBAAA;AADF;ACeE;EDjBF;IAMI,qCAAA;IACA,kBAAA;EAAF;EAEE;IACE,oBAAA;IACA,kBAAA;IACA,iBAAA;EAAJ;AACF;ACUE;EDvBF;IAiBI,qCAAA;IACA,sBAAA;EAAF;EAEE;IACE,oBAAA;IACA,kBAAA;IACA,iBAAA;EAAJ;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-column-gap: 5px;\n\n  @include xl {\n    grid-template-columns: repeat(4, 1fr);\n    grid-row-gap: 16px;\n\n    & > div:nth-of-type(3) {\n      grid-column-start: 1;\n      grid-column-end: 5;\n      grid-row-start: 2;\n    }\n  }\n\n  @include lg {\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: unset;\n\n    & > div:nth-of-type(3) {\n      grid-column-start: 1;\n      grid-column-end: 3;\n      grid-row-start: 3;\n    }\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__n1lvd`
};
export default ___CSS_LOADER_EXPORT___;
